/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketComparable,
    AdminMarketComparableFromJSON,
    AdminMarketComparableFromJSONTyped,
    AdminMarketComparableToJSON,
} from './AdminMarketComparable';
import {
    AdminMarketSnapshotStatus,
    AdminMarketSnapshotStatusFromJSON,
    AdminMarketSnapshotStatusFromJSONTyped,
    AdminMarketSnapshotStatusToJSON,
} from './AdminMarketSnapshotStatus';

/**
 * 
 * @export
 * @interface AdminMarketSnapshot
 */
export interface AdminMarketSnapshot {
    /**
     * 
     * @type {string}
     * @memberof AdminMarketSnapshot
     */
    capturedAt: string;
    /**
     * Comparables closest to the median, by total.
     * @type {Array<AdminMarketComparable>}
     * @memberof AdminMarketSnapshot
     */
    comparables: Array<AdminMarketComparable>;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketSnapshot
     */
    comparablesCount: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketSnapshot
     */
    error?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketSnapshot
     */
    marketHigh?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketSnapshot
     */
    marketLow?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketSnapshot
     */
    marketMedian?: number;
    /**
     * 
     * @type {AdminMarketSnapshotStatus}
     * @memberof AdminMarketSnapshot
     */
    status: AdminMarketSnapshotStatus;
}



export function AdminMarketSnapshotFromJSON(json: any): AdminMarketSnapshot {
    return AdminMarketSnapshotFromJSONTyped(json, false);
}

export function AdminMarketSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketSnapshot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'capturedAt': json['capturedAt'],
        'comparables': ((json['comparables'] as Array<any>).map(AdminMarketComparableFromJSON)),
        'comparablesCount': json['comparablesCount'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'marketHigh': !exists(json, 'marketHigh') ? undefined : json['marketHigh'],
        'marketLow': !exists(json, 'marketLow') ? undefined : json['marketLow'],
        'marketMedian': !exists(json, 'marketMedian') ? undefined : json['marketMedian'],
        'status': AdminMarketSnapshotStatusFromJSON(json['status']),
    };
}

export function AdminMarketSnapshotToJSON(value?: AdminMarketSnapshot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'capturedAt': value.capturedAt,
        'comparables': ((value.comparables as Array<any>).map(AdminMarketComparableToJSON)),
        'comparablesCount': value.comparablesCount,
        'error': value.error,
        'marketHigh': value.marketHigh,
        'marketLow': value.marketLow,
        'marketMedian': value.marketMedian,
        'status': AdminMarketSnapshotStatusToJSON(value.status),
    };
}

